module.exports = __webpack_public_path__ + "hyperion-v2-static/img/test2.823f3999.png";